export default "__VITE_ASSET__B2kd5iz7__"